import { useEffect } from "react";
import { _single, _UpcomingMaintenance } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicTable, MASK_DATE } from "../../../theme/Component/BasicTable";
import { BasicPage } from "../../../theme/Component/BasicPage";


interface componentProps {
    isModal?: boolean
}


export const UpcomingMaintenance = ({ isModal }: componentProps) => {

    const { instance: serviceupcoming, bean, setBean, lista, setLista } = useDataBean(_UpcomingMaintenance);
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const renderMaintenanceInfo = (item: any) => {
        let render =
            ` <div>            
                <strong>Mantenimiento solicitado: </strong><small>${item.DataBeanProperties.MaintenanceName ? item.DataBeanProperties.MaintenanceName : 'NA'}</small><br />            
                <strong>Costo Estimado: </strong><small>${item.DataBeanProperties.MaintenanceCost ? item.DataBeanProperties.MaintenanceCost : 'NA'}</small><br />            
            </div>`
        return render;
    }

    const getLista = () => {
        const Props = {
            State: 1
        }
        serviceupcoming.getUpcomingMaintenanceRender(null, null, Props, _single.getCurrenDate()).then(
            (resp) => {
                resp.List.forEach(element => {

                    const data = element.DataBeanProperties;

                    data.FixedAssetEntity = data.IDFixedAssetItem ? `${data.FixedAssetItemCode ?? ""} - ${data.FixedAssetDescription}` : "N/P";
                    data.MaintenanceEntity = renderMaintenanceInfo(element);
                    console.log(data)
                });
                console.log(resp.List)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
                setBean({});
            }
        ).catch(err => { toast.error(err) })
    };

    const head = [
        { title: 'ID', property: 'IDUpcomingMaintenance', visible: true },
        { title: 'Maquina', property: 'FixedAssetEntity', visible: true },
        { title: 'Mantenimiento Ejecutado', property: 'MaintenanceEntity', visible: true },
        { title: 'Plan de Ejecución', property: 'IDPlanMaintenanceName', visible: true },
        { title: 'Fecha Ejecutada', property: 'ExecutionDate', visible: true },
        { title: 'Fecha Futura', property: 'NextMaintenanceDate', visible: true, mask: MASK_DATE },
        { title: 'Estado', property: 'ExpirationStatus', visible: true },
        { title: 'Usuario', property: 'AccountEntity', visible: true },
    ]



    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </div>
            </div>
        )
    }

    return isModal ? baseComponent() :
        (
            <BasicPage titulo="Mantenimientos Pendientes"  >
                {baseComponent()}
            </BasicPage>
        );
}